module.exports = __webpack_public_path__ + "img/marker.c7f9a62b.svg";